import { render, staticRenderFns } from "./FormTypeDetail.vue?vue&type=template&id=41b338e2&scoped=true"
import script from "./FormTypeDetail.vue?vue&type=script&lang=js"
export * from "./FormTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./FormTypeDetail.vue?vue&type=style&index=0&id=41b338e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b338e2",
  null
  
)

export default component.exports